import Vue from "vue";
import VueRouter from "vue-router";
import LayoutMain from "../layouts/LayoutMain.vue";
import LayoutConsole from "../layouts/LayoutConsole.vue";

//BOC:[state]
import store from "./../store/index";
//EOC

//BOC:[guard]
import multiguard from "vue-router-multiguard";
const loggedIn = function (to, from, next) {
  if (!store.state.account.data) next({ name: "LoginView" });
  next();
};

const notLoggedIn = function (to, from, next) {
  if (store.state.account.data && store.state.account.data.token) {
    next({ name: "DashboardView" });
  }
  next();
};

const shopLoggedIn = function (to, from, next) {
  if (!store.state.account.data || !store.state.account.data.token) {
    next({ name: "ShopLoginView" });
  } else {
    next();
  }
};

const shopNotLoggedIn = function (to, from, next) {
  if (store.state.account.data && store.state.account.data.token) {
    next({ name: "ShopDashboardView" });
  } else {
    next();
  }
};

const deliveryPersonLoggedIn = function (to, from, next) {
  if (!store.state.account.data || !store.state.account.data.token) {
    next({ name: "DeliveryPersonLoginView" });
  } else {
    next();
  }
};

const deliveryPersonNotLoggedIn = function (to, from, next) {
  if (store.state.account.data && store.state.account.data.token) {
    next({ name: "DeliveryPersonDashboardView" });
  } else {
    next();
  }
};

const stallPersonLoggedIn = function (to, from, next) {
  if (!store.state.account.data || !store.state.account.data.token) {
    next({ name: "StallPersonLoginView" });
  } else {
    next();
  }
};

const stallPersonNotLoggedIn = function (to, from, next) {
  if (store.state.account.data && store.state.account.data.token) {
    next({ name: "StallPersonDashboardView" });
  } else {
    next();
  }
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: LayoutMain,
    beforeEnter: multiguard([notLoggedIn]),
    children: [
      {
        path: "",
        name: "LoginView",
        component: () =>
          import(/* webpackChunkName: "login-view" */ "@/views/LoginView.vue"),
        props: true,
      },
    ],
  },
  {
    path: "/shop/login",
    component: LayoutMain,
    beforeEnter: multiguard([shopNotLoggedIn]),
    children: [
      {
        path: "",
        name: "ShopLoginView",
        component: () =>
          import(/* webpackChunkName: "shop-login-view" */ "@/views/shop/loginView.vue"),
        props: true,
        meta: {
          title: "Shop Login",
        },
      },
    ],
  },
  {
    path: "/shop/drop-off",
    component: LayoutMain,
    children: [
      {
        path: "",
        name: "ShopDropOffView",
        component: () =>
          import(/* webpackChunkName: "shop-drop-off-view" */ "@/views/shop/DropOffView.vue"),
        props: true,
        meta: {
          title: "Parcel Drop-Off",
        },
      },
    ],
  },
  {
    path: "/shop/parcel",
    component: LayoutMain,
    children: [
      {
        path: "",
        name: "ShopCollectView",
        component: () =>
          import(/* webpackChunkName: "shop-collect-view" */ "@/views/shop/ShopCollectView.vue"),
        props: true,
        meta: {
          title: "Parcel",
        },
      },
    ],
  },
  {
    path: "/shop/technician",
    component: LayoutMain,
    children: [
      {
        path: "",
        name: "TechnicianOperationView",
        component: () =>
          import(/* webpackChunkName: "shop-technician-operation-view" */ "@/views/shop/TechnicianOperationView.vue"),
        props: true,
        meta: {
          title: "Technician Operations",
        },
      },
    ],
  },
  {
    path: "/shop/dashboard",
    component: LayoutMain,
    beforeEnter: multiguard([shopLoggedIn]),
    children: [
      {
        path: "",
        name: "ShopDashboardView",
        component: () =>
          import(/* webpackChunkName: "shop-dashboard-view" */ "@/views/shop/DashboardView.vue"),
        props: true,
        meta: {
          title: "Shop Dashboard",
        },
      },
    ],
  },
  {
    path: "/stall-person/login",
    component: LayoutMain,
    beforeEnter: multiguard([stallPersonNotLoggedIn]),
    children: [
      {
        path: "",
        name: "StallPersonLoginView",
        component: () =>
          import(/* webpackChunkName: "stall-person-login-view" */ "@/views/stall-persons/loginView.vue"),
        props: true,
        meta: {
          title: "Stall Person Login",
        },
      },
    ],
  },
  {
    path: "/stall-person/dashboard",
    component: LayoutMain,
    beforeEnter: multiguard([stallPersonLoggedIn]),
    children: [
      {
        path: "",
        name: "StallPersonDashboardView",
        component: () =>
          import(/* webpackChunkName: "stall-person-dashboard-view" */ "@/views/stall-persons/DashboardView.vue"),
        props: true,
        meta: {
          title: "Stall Person Dashboard",
        },
      },
    ],
  },
  {
    path: "/delivery-persons/login",
    component: LayoutMain,
    beforeEnter: multiguard([deliveryPersonNotLoggedIn]),
    children: [
      {
        path: "",
        name: "DeliveryPersonLoginView",
        component: () =>
          import(/* webpackChunkName: "delivery-person-login-view" */ "@/views/delivery-persons/loginView.vue"),
        props: true,
        meta: {
          title: "Delivery Person Login",
        },
      },
    ],
  },
  {
    path: "/delivery-persons/parcel-return-booking",
    component: LayoutMain,
    children: [
      {
        path: "",
        name: "ParcelReturnBookingView",
        component: () =>
          import(/* webpackChunkName: "parcel-return-booking-view" */ "@/views/delivery-persons/ParcelReturnBookingView.vue"),
        props: true,
        meta: {
          title: "Parcel Return Booking",
        },
      },
    ],
  },
   {
    path: "/delivery-persons/parcel-collect",
    component: LayoutMain,
    children: [
      {
        path: "",
        name: "ParcelCollectView",
        component: () =>
          import(/* webpackChunkName: "parcel-collect-view" */ "@/views/delivery-persons/ParcelCollectView.vue"),
        props: true,
        meta: {
          title: "Parcel Collect",
        },
      },
    ],
  },
  {
    path: "/delivery-persons/dashboard",
    component: LayoutMain,
    beforeEnter: multiguard([deliveryPersonLoggedIn]),
    children: [
      {
        path: "",
        name: "DeliveryPersonDashboardView",
        component: () =>
          import(/* webpackChunkName: "delivery-person-dashboard-view" */ "@/views/delivery-persons/DashboardView.vue"),
        props: true,
        meta: {
          title: "Delivery Person Dashboard",
        },
      },
    ],
  },
  {
    path: "/trusted-fixers/",
    component: LayoutConsole,
    beforeEnter: multiguard([loggedIn]),
    props: true,
    children: [
      {
        path: "",
        name: "TFDashboardView",
        component: () =>
          import(
            /* webpackChunkName: "tf-dashboard-view" */ "@/views/trusted-fixers/TFDashboardView.vue"
          ),
        props: true,
        meta: {
          title: "Dashboard",
        },
      },
      {
        path: "technicians",
        name: "TFTechnicianBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tf-technician-browse-view" */ "@/views/trusted-fixers/TFTechnicianBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Technicians",
        },
      },
      {
        path: "technicians/new",
        name: "TFTechnicianAddView",
        component: () =>
          import(
            /* webpackChunkName: "tf-technicians-add-view" */ "@/views/trusted-fixers/TFTechnicianAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Technician",
          permission: 127,
        },
      },
      {
        path: "technicians/:uuid",
        name: "TFTechnicianReadView",
        component: () =>
          import(
            /* webpackChunkName: "tf-technicians-read-view" */ "@/views/trusted-fixers/TFTechnicianReadView.vue"
          ),
        props: true,
        meta: {
          title: "Technician Info",
          permission: 127,
        },
      },
      {
        path: "technicians/:uuid/edit",
        name: "TFTechnicianEditView",
        component: () =>
          import(
            /* webpackChunkName: "tf-technicians-edit-view" */ "@/views/trusted-fixers/TFTechnicianEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Technician",
          permission: 127,
        },
      },
      {
        path: "technicians/:uuid/delete",
        name: "TFTechnicianDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "tf-technicians-delete-view" */ "@/views/trusted-fixers/TFTechnicianDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Technician",
          permission: 127,
        },
      },
      {
        path: "package-types",
        name: "TFPackageTypeBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tf-package-type-browse-view" */ "@/views/trusted-fixers/TFPackageTypeBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Package Types",
        },
      },
      {
        path: "package-types/new",
        name: "TFPackageTypeAddView",
        component: () =>
          import(
            /* webpackChunkName: "tf-package-type-add-view" */ "@/views/trusted-fixers/TFPackageTypeAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Package Type",
          permission: 127,
        },
      },
      {
        path: "package-types/:uuid",
        name: "TFPackageTypeReadView",
        component: () =>
          import(
            /* webpackChunkName: "tf-package-type-read-view" */ "@/views/trusted-fixers/TFPackageTypeReadView.vue"
          ),
        props: true,
        meta: {
          title: "Package Type Info",
          permission: 127,
        },
      },
      {
        path: "package-types/:uuid/edit",
        name: "TFPackageTypeEditView",
        component: () =>
          import(
            /* webpackChunkName: "tf-package-type-edit-view" */ "@/views/trusted-fixers/TFPackageTypeEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Package Type",
          permission: 127,
        },
      },
      {
        path: "package-types/:uuid/delete",
        name: "TFPackageTypeDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "tf-package-type-delete-view" */ "@/views/trusted-fixers/TFPackageTypeDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Package Type",
          permission: 127,
        },
      },
      {
        path: "package-types/:parentUuid/packages/new",
        name: "TFPackageAddView",
        component: () =>
          import(
            /* webpackChunkName: "tf-package-add-view" */ "@/views/trusted-fixers/TFPackageAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Package",
          permission: 127,
        },
      },
      {
        path: "package-types/:parentUuid/packages/:uuid",
        name: "TFPackageReadView",
        component: () =>
          import(
            /* webpackChunkName: "tf-package-read-view" */ "@/views/trusted-fixers/TFPackageReadView.vue"
          ),
        props: true,
        meta: {
          title: "Package Info",
          permission: 127,
        },
      },
      {
        path: "package-types/:parentUuid/packages/:uuid/edit",
        name: "TFPackageEditView",
        component: () =>
          import(
            /* webpackChunkName: "tf-package-edit-view" */ "@/views/trusted-fixers/TFPackageEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Package",
          permission: 127,
        },
      },
      {
        path: "package-types/:parentUuid/packages/:uuid/delete",
        name: "TFPackageDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "tf-package-delete-view" */ "@/views/trusted-fixers/TFPackageDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Package",
          permission: 127,
        },
      },
      {
        path: "skills",
        name: "TFSkillBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tf-skill-browse-view" */ "@/views/trusted-fixers/TFSkillBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Skills",
        },
      },
      {
        path: "skills/new",
        name: "TFSkillAddView",
        component: () =>
          import(
            /* webpackChunkName: "tf-skills-add-view" */ "@/views/trusted-fixers/TFSkillAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Skill",
          permission: 127,
        },
      },
      {
        path: "skills/:uuid",
        name: "TFSkillReadView",
        component: () =>
          import(
            /* webpackChunkName: "tf-skills-read-view" */ "@/views/trusted-fixers/TFSkillReadView.vue"
          ),
        props: true,
        meta: {
          title: "Skill Info",
          permission: 127,
        },
      },
      {
        path: "skills/:uuid/edit",
        name: "TFSkillEditView",
        component: () =>
          import(
            /* webpackChunkName: "tf-skills-edit-view" */ "@/views/trusted-fixers/TFSkillEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Skill",
          permission: 127,
        },
      },
      {
        path: "skills/:uuid/delete",
        name: "TFSkillDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "tf-skills-delete-view" */ "@/views/trusted-fixers/TFSkillDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Skill",
          permission: 127,
        },
      },
      {
        path: "customers",
        name: "TFCustomerBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tf-customer-browse-view" */ "@/views/trusted-fixers/TFCustomerBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Customers",
        },
      },
      {
        path: "customers/:uuid",
        name: "TFCustomerReadView",
        component: () =>
          import(
            /* webpackChunkName: "tf-customers-read-view" */ "@/views/trusted-fixers/TFCustomerReadView.vue"
          ),
        props: true,
        meta: {
          title: "Customer Info",
          permission: 127,
        },
      },
      {
        path: "support-requests",
        name: "TFSupportRequestBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tf-support-request-browse-view" */ "@/views/trusted-fixers/TFSupportRequestBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Support Requests",
        },
      },
      {
        path: "free-hour-applications",
        name: "TFFreeHourApplicationBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tf-free-hour-applications-browse-view" */ "@/views/trusted-fixers/TFFreeHourApplicationBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Free Hour Applications",
          permission: 127,
        },
      },
      {
        path: "free-hour-applications/:uuid",
        name: "TFFreeHourApplicationReadView",
        component: () =>
          import(
            /* webpackChunkName: "tf-free-hour-applications-read-view" */ "@/views/trusted-fixers/TFFreeHourApplicationReadView.vue"
          ),
        props: true,
        meta: {
          title: "Free Hour Application Info",
          permission: 127,
        },
      },
      {
        path: "free-hour-applications/:uuid/approve",
        name: "TFFreeHourApplicationApproveView",
        component: () =>
          import(
            /* webpackChunkName: "tf-free-hour-applications-approve-view" */ "@/views/trusted-fixers/TFFreeHourApplicationApproveView.vue"
          ),
        props: true,
        meta: {
          title: "Approve Free Hour Application",
          permission: 127,
        },
      },
      {
        path: "free-hour-applications/:uuid/reject",
        name: "TFFreeHourApplicationRejectView",
        component: () =>
          import(
            /* webpackChunkName: "tf-free-hour-applications-reject-view" */ "@/views/trusted-fixers/TFFreeHourApplicationRejectView.vue"
          ),
        props: true,
        meta: {
          title: "Reject Free Hour Application",
          permission: 127,
        },
      },
      {
        path: "utils",
        name: "TFUtilBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tf-utils-browse-view" */ "@/views/trusted-fixers/TFUtilBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Utils",
          permission: 127,
        },
      },
      {
        path: "utils/new",
        name: "TFUtilAddView",
        component: () =>
          import(
            /* webpackChunkName: "tf-utils-add-view" */ "@/views/trusted-fixers/TFUtilAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Util",
          permission: 127,
        },
      },
      {
        path: "utils/:uuid",
        name: "TFUtilReadView",
        component: () =>
          import(
            /* webpackChunkName: "tf-utils-read-view" */ "@/views/trusted-fixers/TFUtilReadView.vue"
          ),
        props: true,
        meta: {
          title: "Util Info",
          permission: 127,
        },
      },
      {
        path: "utils/:uuid/edit",
        name: "TFUtilEditView",
        component: () =>
          import(
            /* webpackChunkName: "tf-utils-edit-view" */ "@/views/trusted-fixers/TFUtilEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Util",
          permission: 127,
        },
      },
    ],
  },
  {
    path: "/",
    component: LayoutConsole,
    beforeEnter: multiguard([loggedIn]),
    props: true,
    children: [
      {
        path: "dashboard",
        name: "DashboardView",
        component: () =>
          import(
            /* webpackChunkName: "dashboard-view" */ "@/views/user/DashboardView.vue"
          ),
        props: true,
        meta: {
          title: "Dashboard",
        },
      },
      {
        path: "calendar-alerts",
        name: "CalendarAlertsView",
        component: () =>
          import(
            /* webpackChunkName: "calendar-alerts-view" */ "@/views/user/CalendarAlertsView.vue"
          ),
        props: true,
        meta: {
          title: "Calendar",
          permission: 183,
        },
      },
      {
        path: "calendar",
        name: "CalendarView",
        component: () =>
          import(
            /* webpackChunkName: "dashboard-view" */ "@/views/user/CalendarView.vue"
          ),
        props: true,
        meta: {
          title: "Calendar",
          permission: 57,
        },
      },
      {
        path: "calendar/manage-working-hours",
        name: "CalendarWorkingHoursView",
        component: () =>
          import(
            /* webpackChunkName: "manage-working-hours-view" */ "@/views/user/CalendarWorkingHoursView.vue"
          ),
        props: true,
        meta: {
          title: "Manage Working Hours",
          permission: 118,
        },
      },
      {
        path: "sales-person-calendar",
        name: "SalesPersonCalendarView",
        component: () =>
          import(
            /* webpackChunkName: "dashboard-view" */ "@/views/user/SalesPersonCalendarView.vue"
          ),
        props: true,
        meta: {
          title: "Calendar",
          permission: 69,
        },
      },
      {
        path: "mail-templates",
        name: "MailTemplateBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "mail-template-browse-view" */ "@/views/user/MailTemplateBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Mail Templates",
          permission: 64,
        },
      },
      {
        path: "mail-templates/new",
        name: "MailTemplateAddView",
        component: () =>
          import(
            /* webpackChunkName: "mail-templates-add-view" */ "@/views/user/MailTemplateAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Mail Template",
          permission: 63,
        },
      },
      {
        path: "mail-templates/:uuid",
        name: "MailTemplateReadView",
        component: () =>
          import(
            /* webpackChunkName: "mail-templates-read-view" */ "@/views/user/MailTemplateReadView.vue"
          ),
        props: true,
        meta: {
          title: "Mail Template Info",
          permission: 64,
        },
      },
      {
        path: "mail-templates/:uuid/edit",
        name: "MailTemplateEditView",
        component: () =>
          import(
            /* webpackChunkName: "mail-templates-edit-view" */ "@/views/user/MailTemplateEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Mail Template",
          permission: 65,
        },
      },
      {
        path: "mail-templates/:uuid/delete",
        name: "MailTemplateDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "mail-templates-delete-view" */ "@/views/user/MailTemplateDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Mail Template",
          permission: 66,
        },
      },
      {
        path: "admins",
        name: "AdminBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "admins-browse-view" */ "@/views/user/AdminBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Admins",
          permission: 2,
        },
      },
      {
        path: "admins/new",
        name: "AdminAddView",
        component: () =>
          import(
            /* webpackChunkName: "admins-add-view" */ "@/views/user/AdminAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Admin",
          permission: 1,
        },
      },
      {
        path: "admins/:uuid",
        name: "AdminReadView",
        component: () =>
          import(
            /* webpackChunkName: "admins-read-view" */ "@/views/user/AdminReadView.vue"
          ),
        props: true,
        meta: {
          title: "Admin Info",
          permission: 2,
        },
      },
      {
        path: "admins/:uuid/edit",
        name: "AdminEditView",
        component: () =>
          import(
            /* webpackChunkName: "admins-edit-view" */ "@/views/user/AdminEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Admin",
          permission: 3,
        },
      },
      {
        path: "admins/:uuid/delete",
        name: "AdminDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "admins-delete-view" */ "@/views/user/AdminDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Admin",
          permission: 4,
        },
      },
      {
        path: "testify-admins",
        name: "QuizUserBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "testify-admins-browse-view" */ "@/views/user/QuizUserBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Testify Admins",
          permission: 110,
        },
      },
      {
        path: "testify-admins/new",
        name: "QuizUserAddView",
        component: () =>
          import(
            /* webpackChunkName: "testify-admins-add-view" */ "@/views/user/QuizUserAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Testify Admin",
          permission: 111,
        },
      },
      {
        path: "testify-admins/:uuid",
        name: "QuizUserReadView",
        component: () =>
          import(
            /* webpackChunkName: "testify-admins-read-view" */ "@/views/user/QuizUserReadView.vue"
          ),
        props: true,
        meta: {
          title: "Testify Admin Info",
          permission: 110,
        },
      },
      {
        path: "testify-admins/:uuid/edit",
        name: "QuizUserEditView",
        component: () =>
          import(
            /* webpackChunkName: "testify-admins-edit-view" */ "@/views/user/QuizUserEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Testify Admin",
          permission: 112,
        },
      },
      {
        path: "testify-admins/:uuid/delete",
        name: "QuizUserDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "testify-admins-delete-view" */ "@/views/user/QuizUserDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Testify Admin",
          permission: 113,
        },
      },
      {
        path: "contracts",
        name: "ContractsBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "contracts-browse-view" */ "@/views/user/ContractsBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Contracts",
          permission: 159,
        },
      },
      {
        path: "contracts/:uuid",
        name: "ContractReadView",
        component: () =>
          import(
            /* webpackChunkName: "contracts-read-view" */ "@/views/user/ContractReadView.vue"
          ),
        props: true,
        meta: {
          title: "Contract Info",
          permission: 159,
        },
      },
      {
        path: "contracts/:uuid/approve",
        name: "ContractApproveView",
        component: () =>
          import(
            /* webpackChunkName: "contracts-approve-view" */ "@/views/user/ContractApproveView.vue"
          ),
        props: true,
        meta: {
          title: "Approve Contract",
          permission: 160,
        },
      },
      {
        path: "assets-overview",
        name: "TechnicianAssetOverviewView",
        component: () =>
          import(
            /* webpackChunkName: "technician-assets-overview-view" */ "@/views/user/TechnicianAssetOverviewView.vue"
          ),
        props: true,
        meta: {
          title: "Assets Overview",
          permission: 182,
        },
      },
      {
        path: "admin-assets",
        name: "AdminAssetBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "admin-assets-browse-view" */ "@/views/user/AdminAssetBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Assets",
          permission: 156,
        },
      },
      {
        path: "admin-assets/new",
        name: "AdminAssetAddView",
        component: () =>
          import(
            /* webpackChunkName: "admin-assets-add-view" */ "@/views/user/AdminAssetAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Asset",
          permission: 155,
        },
      },
      {
        path: "admin-assets/:uuid",
        name: "AdminAssetReadView",
        component: () =>
          import(
            /* webpackChunkName: "admin-assets-read-view" */ "@/views/user/AdminAssetReadView.vue"
          ),
        props: true,
        meta: {
          title: "Asset Info",
          permission: 156,
        },
      },
      {
        path: "admin-assets/:uuid/edit",
        name: "AdminAssetEditView",
        component: () =>
          import(
            /* webpackChunkName: "admin-assets-edit-view" */ "@/views/user/AdminAssetEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Asset",
          permission: 157,
        },
      },
      {
        path: "admin-assets/:uuid/delete",
        name: "AdminAssetDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "admin-assets-delete-view" */ "@/views/user/AdminAssetDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Asset",
          permission: 158,
        },
      },
      {
        path: "assets",
        name: "AssetBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-users-browse-view" */ "@/views/user/AssetBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Assets",
          permission: 150,
        },
      },
      {
        path: "assets/new",
        name: "AssetAddView",
        component: () =>
          import(
            /* webpackChunkName: "assets-add-view" */ "@/views/user/AssetAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Asset",
          permission: 149,
        },
      },
       {
        path: "assets/generate-tags",
        name: "AssetTagGenerateView",
        component: () =>
          import(
            /* webpackChunkName: "assets-generate-tags-view" */ "@/views/user/AssetTagGenerateView.vue"
          ),
        props: true,
        meta: {
          title: "Generate Asset Tags",
          permission: 149,
        },
      },
       {
        path: "assets/checkout",
        name: "AssetCheckoutView",
        component: () =>
          import(
            /* webpackChunkName: "assets-checkout-view" */ "@/views/user/AssetCheckoutView.vue"
          ),
        props: true,
        meta: {
          title: "Checkout Asset",
          permission: 153,
        },
      },
      {
        path: "assets/checkin",
        name: "AssetCheckinView",
        component: () =>
          import(
            /* webpackChunkName: "assets-checkin-view" */ "@/views/user/AssetCheckinView.vue"
          ),
        props: true,
        meta: {
          title: "Checkin Asset",
          permission: 154,
        },
      },
      {
        path: "assets/mark-as-available",
        name: "AssetMarkAsAvailableView",
        component: () =>
          import(
            /* webpackChunkName: "assets-mark-as-available-view" */ "@/views/user/AssetMarkAsAvailableView.vue"
          ),
        props: true,
        meta: {
          title: "Mark As Available Asset",
          permission: 168,
        },
      },
      {
        path: "assets/manage-status",
        name: "AssetStatusManageView",
        component: () =>
          import(
            /* webpackChunkName: "assets-status-manage-view" */ "@/views/user/AssetStatusManageView.vue"
          ),
        props: true,
        meta: {
          title: "Manage Asset Status",
          permission: 153,
        },
      },
      {
        path: "assets/:uuid",
        name: "AssetReadView",
        component: () =>
          import(
            /* webpackChunkName: "assets-read-view" */ "@/views/user/AssetReadView.vue"
          ),
        props: true,
        meta: {
          title: "Asset Info",
          permission: 150,
        },
      },
      {
        path: "assets/:uuid/edit",
        name: "AssetEditView",
        component: () =>
          import(
            /* webpackChunkName: "assets-edit-view" */ "@/views/user/AssetEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Asset",
          permission: 151,
        },
      },
      {
        path: "assets/:uuid/delete",
        name: "AssetDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "assets-delete-view" */ "@/views/user/AssetDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Asset",
          permission: 152,
        },
      },
      {
        path: "clockwise-users",
        name: "ClockWiseUserBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-users-browse-view" */ "@/views/user/ClockWiseUserBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "ClockWise Users",
          permission: 145,
        },
      },
      {
        path: "clockwise-users/new",
        name: "ClockWiseUserAddView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-users-add-view" */ "@/views/user/ClockWiseUserAddView.vue"
          ),
        props: true,
        meta: {
          title: "New ClockWise User",
          permission: 144,
        },
      },
      {
        path: "clockwise-users/:uuid",
        name: "ClockWiseUserReadView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-users-read-view" */ "@/views/user/ClockWiseUserReadView.vue"
          ),
        props: true,
        meta: {
          title: "ClockWise User Info",
          permission: 145,
        },
      },
      {
        path: "clockwise-users/:uuid/activities",
        name: "ClockWiseUserActivityView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-users-activity-view" */ "@/views/user/ClockWiseUserActivityView.vue"
          ),
        props: true,
        meta: {
          title: "ClockWise User Activity",
          permission: 148,
        },
      },
      {
        path: "clockwise-users/:uuid/mark-as-paid",
        name: "ClockWiseUserMarkAsPaidView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-users-mark-as-paid-view" */ "@/views/user/ClockWiseUserMarkAsPaidView.vue"
          ),
        props: true,
        meta: {
          title: "ClockWise User Mark As Paid",
          permission: 169,
        },
      },
      {
        path: "clockwise-users/:uuid/edit",
        name: "ClockWiseUserEditView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-users-edit-view" */ "@/views/user/ClockWiseUserEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit ClockWise User",
          permission: 146,
        },
      },
      {
        path: "clockwise-users/:uuid/reset-password",
        name: "ClockWiseUserPasswordResetView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-users-reset-password-view" */ "@/views/user/ClockWiseUserPasswordResetView.vue"
          ),
        props: true,
        meta: {
          title: "Reset Password ClockWise User",
          permission: 146,
        },
      },
      {
        path: "clockwise-users/:uuid/delete",
        name: "ClockWiseUserDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-users-delete-view" */ "@/views/user/ClockWiseUserDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete ClockWise User",
          permission: 147,
        },
      },
      {
        path: "technicians",
        name: "TechnicianBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-browse-view" */ "@/views/user/TechnicianBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Technicians",
          permission: 6,
        },
      },
      {
        path: "technicians/new",
        name: "TechnicianAddView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-add-view" */ "@/views/user/TechnicianAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Technician",
          permission: 5,
        },
      },
      {
        path: "technicians/:uuid",
        name: "TechnicianReadView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-read-view" */ "@/views/user/TechnicianReadView.vue"
          ),
        props: true,
        meta: {
          title: "Technician Info",
          permission: 6,
        },
      },
      {
        path: "technicians/:uuid/edit",
        name: "TechnicianEditView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-edit-view" */ "@/views/user/TechnicianEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Technician",
          permission: 7,
        },
      },
      {
        path: "technicians/:uuid/delete",
        name: "TechnicianDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-delete-view" */ "@/views/user/TechnicianDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Technician",
          permission: 8,
        },
      },
       {
        path: "stall-persons",
        name: "StallPersonBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "stall-persons-browse-view" */ "@/views/user/StallPersonBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Stall Persons",
          permission: 205,
        },
      },
      {
        path: "stall-persons/new",
        name: "StallPersonAddView",
        component: () =>
          import(
            /* webpackChunkName: "stall-persons-add-view" */ "@/views/user/StallPersonAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Stall Person",
          permission: 204,
        },
      },
      {
        path: "stall-persons/:uuid",
        name: "StallPersonReadView",
        component: () =>
          import(
            /* webpackChunkName: "stall-persons-read-view" */ "@/views/user/StallPersonReadView.vue"
          ),
        props: true,
        meta: {
          title: "Stall Person Info",
          permission: 205,
        },
      },
        {
        path: "stall-persons/:uuid/mark-as-paid",
        name: "StallPersonMarkAsPaidView",
        component: () =>
          import(
            /* webpackChunkName: "stall-persons-mark-as-paid-view" */ "@/views/user/StallPersonMarkAsPaidView.vue"
          ),
        props: true,
        meta: {
          title: "Delivery Person Mark As Paid",
          permission: 208,
        },
      },
      {
        path: "stall-persons/:uuid/edit",
        name: "StallPersonEditView",
        component: () =>
          import(
            /* webpackChunkName: "stall-persons-edit-view" */ "@/views/user/StallPersonEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Stall Person",
          permission: 206,
        },
      },
      {
        path: "stall-persons/:uuid/delete",
        name: "StallPersonDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "stall-persons-delete-view" */ "@/views/user/StallPersonDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Stall Person",
          permission: 207,
        },
      },
      {
        path: "delivery-persons",
        name: "DeliveryPersonBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "delivery-persons-browse-view" */ "@/views/user/DeliveryPersonBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Delivery Persons",
          permission: 189,
        },
      },
      {
        path: "delivery-persons/new",
        name: "DeliveryPersonAddView",
        component: () =>
          import(
            /* webpackChunkName: "delivery-persons-add-view" */ "@/views/user/DeliveryPersonAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Delivery Person",
          permission: 188,
        },
      },
      {
        path: "delivery-persons/:uuid",
        name: "DeliveryPersonReadView",
        component: () =>
          import(
            /* webpackChunkName: "delivery-persons-read-view" */ "@/views/user/DeliveryPersonReadView.vue"
          ),
        props: true,
        meta: {
          title: "Delivery Person Info",
          permission: 189,
        },
      },
        {
        path: "delivery-persons/:uuid/mark-as-paid",
        name: "DeliveryPersonMarkAsPaidView",
        component: () =>
          import(
            /* webpackChunkName: "delivery-persons-mark-as-paid-view" */ "@/views/user/DeliveryPersonMarkAsPaidView.vue"
          ),
        props: true,
        meta: {
          title: "Delivery Person Mark As Paid",
          permission: 192,
        },
      },
      {
        path: "delivery-persons/:uuid/edit",
        name: "DeliveryPersonEditView",
        component: () =>
          import(
            /* webpackChunkName: "delivery-persons-edit-view" */ "@/views/user/DeliveryPersonEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Delivery Person",
          permission: 190,
        },
      },
      {
        path: "delivery-persons/:uuid/delete",
        name: "DeliveryPersonDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "delivery-persons-delete-view" */ "@/views/user/DeliveryPersonDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Delivery Person",
          permission: 191,
        },
      },
      {
        path: "technicians/:uuid/products/manage",
        name: "TechnicianProductManageView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-product-manage-view" */ "@/views/user/TechnicianProductManageView.vue"
          ),
        props: true,
        meta: {
          title: "Manage Technician Products",
          permission: 174,
        },
      },
      {
        path: "technicians/:uuid/tags/manage",
        name: "TechnicianTagManageView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-tag-manage-view" */ "@/views/user/TechnicianTagManageView.vue"
          ),
        props: true,
        meta: {
          title: "Manage Technician Tags",
          permission: 175,
        },
      },
      {
        path: "technicians/:uuid/products/import",
        name: "TechnicianProductImportView",
        component: () =>
          import(
            /* webpackChunkName: "technicians-product-import-view" */ "@/views/user/TechnicianProductImportView.vue"
          ),
        props: true,
        meta: {
          title: "Import Technician Products",
          permission: 8,
        },
      },
      {
        path: "transactions",
        name: "WiseTransactionBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "transactions-browse-view" */ "@/views/user/WiseTransactionBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Transactions",
          permission: 39,
        },
      },
      {
        path: "transactions/:uuid",
        name: "WiseTransactionReadView",
        component: () =>
          import(
            /* webpackChunkName: "transactions-read-view" */ "@/views/user/WiseTransactionReadView.vue"
          ),
        props: true,
        meta: {
          title: "Transaction Info",
          permission: 10,
        },
      },
      {
        path: "customer-details-requests",
        name: "CustomerDetailsRequestBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "customer-details-requests-browse-view" */ "@/views/user/CustomerDetailsRequestBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Customer Details Requests",
          permission: 121,
        },
      },
      {
        path: "customer-details-requests/:uuid",
        name: "CustomerDetailsRequestReadView",
        component: () =>
          import(
            /* webpackChunkName: "customer-details-requests-read-view" */ "@/views/user/CustomerDetailsRequestReadView.vue"
          ),
        props: true,
        meta: {
          title: "Customer Details Request Info",
          permission: 121,
        },
      },
      {
        path: "customer-details-requests/:uuid/approve",
        name: "CustomerDetailsRequestApproveView",
        component: () =>
          import(
            /* webpackChunkName: "customer-details-requests-approve-view" */ "@/views/user/CustomerDetailsRequestApproveView.vue"
          ),
        props: true,
        meta: {
          title: "Approve Customer Details Request",
          permission: 122,
        },
      },
      {
        path: "customer-details-requests/:uuid/reject",
        name: "CustomerDetailsRequestRejectView",
        component: () =>
          import(
            /* webpackChunkName: "customer-details-requests-reject-view" */ "@/views/user/CustomerDetailsRequestRejectView.vue"
          ),
        props: true,
        meta: {
          title: "Reject Customer Details Request",
          permission: 123,
        },
      },
      {
        path: "audio-split-requests",
        name: "AudioSplitRequestBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "audio-split-requests-browse-view" */ "@/views/user/AudioSplitRequestBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Enhancement Requests",
          permission: 135,
        },
      },
      {
        path: "audio-split-requests/new",
        name: "AudioSplitRequestAddView",
        component: () =>
          import(
            /* webpackChunkName: "audio-split-requests-add-view" */ "@/views/user/AudioSplitRequestAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Audio Split Request",
          permission: 136,
        },
      },
      {
        path: "audio-split-requests/:uuid",
        name: "AudioSplitRequestReadView",
        component: () =>
          import(
            /* webpackChunkName: "audio-split-requests-read-view" */ "@/views/user/AudioSplitRequestReadView.vue"
          ),
        props: true,
        meta: {
          title: "Audio Split Request Info",
          permission: 135,
        },
      },
      {
        path: "enhancement-requests",
        name: "EnhancementRequestBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "enhancement-requests-browse-view" */ "@/views/user/EnhancementRequestBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Enhancement Requests",
          permission: 93,
        },
      },
      {
        path: "enhancement-requests/new",
        name: "EnhancementRequestAddView",
        component: () =>
          import(
            /* webpackChunkName: "enhancement-requests-add-view" */ "@/views/user/EnhancementRequestAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Enhancement Request",
          permission: 94,
        },
      },
      {
        path: "enhancement-requests/:uuid",
        name: "EnhancementRequestReadView",
        component: () =>
          import(
            /* webpackChunkName: "enhancement-requests-read-view" */ "@/views/user/EnhancementRequestReadView.vue"
          ),
        props: true,
        meta: {
          title: "Enhancement Request Info",
          permission: 93,
        },
      },
      {
        path: "enhancement-requests/:uuid/delete",
        name: "EnhancementRequestDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "enhancement-requests-delete-view" */ "@/views/user/EnhancementRequestDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Enhancement Request",
          permission: 96,
        },
      },
      {
        path: "enhancement-requests/:uuid/upload",
        name: "EnhancementRequestUploadView",
        component: () =>
          import(
            /* webpackChunkName: "enhancement-requests-upload-view" */ "@/views/user/EnhancementRequestUploadView.vue"
          ),
        props: true,
        meta: {
          title: "Upload Enhancement Request",
          permission: 95,
        },
      },
      {
        path: "credits",
        name: "WiseCreditBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "credits-browse-view" */ "@/views/user/WiseCreditBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Credits",
          permission: 92,
        },
      },
      {
        path: "credits/:uuid",
        name: "WiseCreditReadView",
        component: () =>
          import(
            /* webpackChunkName: "credits-read-view" */ "@/views/user/WiseCreditReadView.vue"
          ),
        props: true,
        meta: {
          title: "Credit Info",
          permission: 92,
        },
      },
      {
        path: "credits/:uuid/transfer",
        name: "WiseCreditTransferView",
        component: () =>
          import(
            /* webpackChunkName: "wise-credits-transfer-view" */ "@/views/user/WiseCreditTransferView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Wise Credit",
          permission: 56,
        },
      },
      {
        path: "wise-jars",
        name: "WiseJarBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "wise-jars-browse-view" */ "@/views/user/WiseJarBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Wise Jars",
          permission: 54,
        },
      },
      {
        path: "wise-jars/sync",
        name: "WiseJarSyncView",
        component: () =>
          import(
            /* webpackChunkName: "wise-jars-sync-view" */ "@/views/user/WiseJarSyncView.vue"
          ),
        props: true,
        meta: {
          title: "Sync Jars",
          permission: 53,
        },
      },
      {
        path: "wise-jars/:uuid",
        name: "WiseJarReadView",
        component: () =>
          import(
            /* webpackChunkName: "wise-jars-read-view" */ "@/views/user/WiseJarReadView.vue"
          ),
        props: true,
        meta: {
          title: "Wise Jar Info",
          permission: 54,
        },
      },
      {
        path: "wise-jars/:uuid/edit",
        name: "WiseJarEditView",
        component: () =>
          import(
            /* webpackChunkName: "wise-jars-edit-view" */ "@/views/user/WiseJarEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Wise Jar",
          permission: 55,
        },
      },
      {
        path: "wise-users",
        name: "WiseUserBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "wise-users-browse-view" */ "@/views/user/WiseUserBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Wise Users",
          permission: 39,
        },
      },
      {
        path: "wise-users/sync",
        name: "WiseUserSyncView",
        component: () =>
          import(
            /* webpackChunkName: "wise-users-sync-view" */ "@/views/user/WiseUserSyncView.vue"
          ),
        props: true,
        meta: {
          title: "Sync Users",
          permission: 38,
        },
      },
      {
        path: "wise-users/:uuid",
        name: "WiseUserReadView",
        component: () =>
          import(
            /* webpackChunkName: "wise-users-read-view" */ "@/views/user/WiseUserReadView.vue"
          ),
        props: true,
        meta: {
          title: "Wise User Info",
          permission: 39,
        },
      },
      {
        path: "wise-users/:uuid/edit",
        name: "WiseUserEditView",
        component: () =>
          import(
            /* webpackChunkName: "wise-users-edit-view" */ "@/views/user/WiseUserEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Wise User",
          permission: 40,
        },
      },
      {
        path: "users",
        name: "UserBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "users-browse-view" */ "@/views/user/UserBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Users",
          permission: 10,
        },
      },
      {
        path: "users/new",
        name: "UserAddView",
        component: () =>
          import(
            /* webpackChunkName: "users-add-view" */ "@/views/user/UserAddView.vue"
          ),
        props: true,
        meta: {
          title: "New User",
          permission: 9,
        },
      },
      {
        path: "users/:uuid",
        name: "UserReadView",
        component: () =>
          import(
            /* webpackChunkName: "users-read-view" */ "@/views/user/UserReadView.vue"
          ),
        props: true,
        meta: {
          title: "User Info",
          permission: 10,
        },
      },
      {
        path: "users/:uuid/edit",
        name: "UserEditView",
        component: () =>
          import(
            /* webpackChunkName: "users-edit-view" */ "@/views/user/UserEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit User",
          permission: 11,
        },
      },
      {
        path: "users/:uuid/delete",
        name: "UserDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "users-delete-view" */ "@/views/user/UserDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete User",
          permission: 12,
        },
      },
       {
        path: "stall-activities",
        name: "StallActivityBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "stall-activity-browse-view" */ "@/views/user/StallActivityBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Stall Activities",
          permission: 213,
        },
      },
      {
        path: "stall-activities/:uuid",
        name: "StallActivityReadView",
        component: () =>
          import(
            /* webpackChunkName: "stall-activity-read-view" */ "@/views/user/StallActivityReadView.vue"
          ),
        props: true,
        meta: {
          title: "Stall Activity Info",
          permission: 213,
        },
      },
      {
        path: "stall-activities/:uuid/delete",
        name: "StallActivityDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "stall-activity-delete-view" */ "@/views/user/StallActivityDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Stall Activity",
          permission: 214,
        },
      },
      {
        path: "activity-logs",
        name: "ActivityLogBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "activity-log-browse-view" */ "@/views/user/ActivityLogBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Activity Logs",
          permission: 17,
        },
      },
      {
        path: "activity-logs/:uuid",
        name: "ActivityLogReadView",
        component: () =>
          import(
            /* webpackChunkName: "activity-log-read-view" */ "@/views/user/ActivityLogReadView.vue"
          ),
        props: true,
        meta: {
          title: "Activity Log Info",
          permission: 17,
        },
      },
      {
        path: "activity-logs/:uuid/delete",
        name: "ActivityLogDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "activity-log-delete-view" */ "@/views/user/ActivityLogDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Activity Log",
          permission: 18,
        },
      },
      {
        path: "countries",
        name: "CountryBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "countries-browse-view" */ "@/views/user/CountryBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Countries",
          permission: 20,
        },
      },
      {
        path: "countries/new",
        name: "CountryAddView",
        component: () =>
          import(
            /* webpackChunkName: "countries-add-view" */ "@/views/user/CountryAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Country",
          permission: 19,
        },
      },
      {
        path: "countries/:uuid",
        name: "CountryReadView",
        component: () =>
          import(
            /* webpackChunkName: "countries-read-view" */ "@/views/user/CountryReadView.vue"
          ),
        props: true,
        meta: {
          title: "Country Info",
          permission: 20,
        },
      },
      {
        path: "countries/:uuid/edit",
        name: "CountryEditView",
        component: () =>
          import(
            /* webpackChunkName: "countries-edit-view" */ "@/views/user/CountryEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Country",
          permission: 28,
        },
      },
      {
        path: "countries/:uuid/delete",
        name: "CountryDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "countries-delete-view" */ "@/views/user/CountryDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Country",
          permission: 21,
        },
      },
      {
        path: "deals",
        name: "DealBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "deals-browse-view" */ "@/views/user/DealBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Deals",
          permission: 37,
        },
      },
      {
        path: "deals/:uuid",
        name: "DealReadView",
        component: () =>
          import(
            /* webpackChunkName: "deals-read-view" */ "@/views/user/DealReadView.vue"
          ),
        props: true,
        meta: {
          title: "Deal Info",
          permission: 37,
        },
      },
      {
        path: "deals/:uuid/mark-as-paid",
        name: "DealInvoiceMarkAsPaidView",
        component: () =>
          import(
            /* webpackChunkName: "deals-mark-as-paid-view" */ "@/views/user/DealInvoiceMarkAsPaidView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Paid",
          permission: 86,
        },
      },
      {
        path: "deals/:uuid/mark-as-lost",
        name: "DealMarkAsLostView",
        component: () =>
          import(
            /* webpackChunkName: "deals-mark-as-lost-view" */ "@/views/user/DealMarkAsLostView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Lost",
          permission: 126,
        },
      },
      {
        path: "deals/:uuid/summary",
        name: "DealSummaryView",
        component: () =>
          import(
            /* webpackChunkName: "deals-summary-view" */ "@/views/user/DealSummaryView.vue"
          ),
        props: true,
        meta: {
          title: "Deal Summary",
          permission: 84,
        },
      },
      {
        path: "report",
        name: "ReportBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "report-browse-view" */ "@/views/user/ReportBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Report",
          permission: 68,
        },
      },
      {
        path: "income-report",
        name: "IncomeReportBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "income-report-browse-view" */ "@/views/user/IncomeReportBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Income Report",
          permission: 82,
        },
      },
      {
        path: "locations",
        name: "LocationBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "locations-browse-view" */ "@/views/user/LocationBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Locations",
          permission: 27,
        },
      },
      {
        path: "locations/new",
        name: "LocationAddView",
        component: () =>
          import(
            /* webpackChunkName: "locations-add-view" */ "@/views/user/LocationAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Location",
          permission: 26,
        },
      },
      {
        path: "locations/:uuid",
        name: "LocationReadView",
        component: () =>
          import(
            /* webpackChunkName: "locations-read-view" */ "@/views/user/LocationReadView.vue"
          ),
        props: true,
        meta: {
          title: "Location Info",
          permission: 27,
        },
      },
      {
        path: "locations/:uuid/edit",
        name: "LocationEditView",
        component: () =>
          import(
            /* webpackChunkName: "locations-edit-view" */ "@/views/user/LocationEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Location",
          permission: 28,
        },
      },
      {
        path: "locations/:uuid/delete",
        name: "LocationDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "locations-delete-view" */ "@/views/user/LocationDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Product",
          permission: 29,
        },
      },
      {
        path: "location-pages",
        name: "LocationPageBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "location-pages-browse-view" */ "@/views/location-pages/LocationPageBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Location Pages",
          permission: 219,
        },
      },
      {
        path: "location-pages/:uuid",
        name: "LocationPageReviewView",
        component: () =>
          import(
            /* webpackChunkName: "location-pages-review-view" */ "@/views/location-pages/LocationPageReviewView.vue"
          ),
        props: true,
        meta: {
          title: "Review Location Page",
          permission: 219,
        },
      },
      {
        path: "tape-estimates",
        name: "TapeEstimateBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tape-estimates-browse-view" */ "@/views/user/TapeEstimateBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Tape Estimates",
          permission: 223,
        },
      },
      {
        path: "tape-estimates/:uuid",
        name: "TapeEstimateReadView",
        component: () =>
          import(
            /* webpackChunkName: "tape-estimates-read-view" */ "@/views/user/TapeEstimateReadView.vue"
          ),
        props: true,
        meta: {
          title: "Tape Estimate Info",
          permission: 223,
        },
      },
      {
        path: "tape-estimates/:uuid/edit",
        name: "TapeEstimateEditView",
        component: () =>
          import(
            /* webpackChunkName: "tape-estimates-edit-view" */ "@/views/user/TapeEstimateEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Tape Estimate",
          permission: 224,
        },
      },
      {
        path: "tape-estimates/:uuid/delete",
        name: "TapeEstimateDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "tape-estimates-delete-view" */ "@/views/user/TapeEstimateDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Tape Estimate",
          permission: 225,
        },
      },
      {
        path: "poster-locations",
        name: "PosterLocationBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "poster-locations-browse-view" */ "@/views/user/PosterLocationBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Poster Locations",
          permission: 194,
        },
      },
      {
        path: "poster-locations/new",
        name: "PosterLocationAddView",
        component: () =>
          import(
            /* webpackChunkName: "poster-locations-add-view" */ "@/views/user/PosterLocationAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Poster Location",
          permission: 193,
        },
      },
      {
        path: "poster-locations/:uuid",
        name: "PosterLocationReadView",
        component: () =>
          import(
            /* webpackChunkName: "poster-locations-read-view" */ "@/views/user/PosterLocationReadView.vue"
          ),
        props: true,
        meta: {
          title: "Poster Location Info",
          permission: 194,
        },
      },
      {
        path: "poster-locations/:uuid/edit",
        name: "PosterLocationEditView",
        component: () =>
          import(
            /* webpackChunkName: "poster-locations-edit-view" */ "@/views/user/PosterLocationEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Poster Location",
          permission: 195,
        },
      },
      {
        path: "poster-locations/:uuid/delete",
        name: "PosterLocationDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "poster-locations-delete-view" */ "@/views/user/PosterLocationDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Poster Location",
          permission: 196,
        },
      },
      {
        path: "cities",
        name: "CityBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "cities-browse-view" */ "@/views/user/CityBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Cities",
          permission: 185,
        },
      },
      {
        path: "cities/new",
        name: "CityAddView",
        component: () =>
          import(
            /* webpackChunkName: "cities-add-view" */ "@/views/user/CityAddView.vue"
          ),
        props: true,
        meta: {
          title: "New City",
          permission: 184,
        },
      },
      {
        path: "cities/:uuid",
        name: "CityReadView",
        component: () =>
          import(
            /* webpackChunkName: "cities-read-view" */ "@/views/user/CityReadView.vue"
          ),
        props: true,
        meta: {
          title: "City Info",
          permission: 185,
        },
      },
      {
        path: "cities/:uuid/edit",
        name: "CityEditView",
        component: () =>
          import(
            /* webpackChunkName: "cities-edit-view" */ "@/views/user/CityEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit City",
          permission: 186,
        },
      },
      {
        path: "cities/:uuid/delete",
        name: "CityDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "cities-delete-view" */ "@/views/user/CityDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete City",
          permission: 187,
        },
      },
      {
        path: "file-types",
        name: "FileTypeBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "file-types-browse-view" */ "@/views/user/FileTypeBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "File Types",
          permission: 46,
        },
      },
      {
        path: "file-types/new",
        name: "FileTypeAddView",
        component: () =>
          import(
            /* webpackChunkName: "file-types-add-view" */ "@/views/user/FileTypeAddView.vue"
          ),
        props: true,
        meta: {
          title: "New File Type",
          permission: 88,
        },
      },
      {
        path: "file-types/:uuid",
        name: "FileTypeReadView",
        component: () =>
          import(
            /* webpackChunkName: "file-types-read-view" */ "@/views/user/FileTypeReadView.vue"
          ),
        props: true,
        meta: {
          title: "File Type Info",
          permission: 89,
        },
      },
      {
        path: "file-types/:uuid/edit",
        name: "FileTypeEditView",
        component: () =>
          import(
            /* webpackChunkName: "file-types-edit-view" */ "@/views/user/FileTypeEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit File Type",
          permission: 90,
        },
      },
      {
        path: "file-types/:uuid/delete",
        name: "FileTypeDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "file-types-delete-view" */ "@/views/user/FileTypeDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete File Type",
          permission: 91,
        },
      },
      {
        path: "links",
        name: "LinkBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "links-browse-view" */ "@/views/user/LinkBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Links",
          permission: 216,
        },
      },
      {
        path: "links/new",
        name: "LinkAddView",
        component: () =>
          import(
            /* webpackChunkName: "links-add-view" */ "@/views/user/LinkAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Link",
          permission: 215,
        },
      },
      {
        path: "links/:uuid",
        name: "LinkReadView",
        component: () =>
          import(
            /* webpackChunkName: "links-read-view" */ "@/views/user/LinkReadView.vue"
          ),
        props: true,
        meta: {
          title: "Link Info",
          permission: 216,
        },
      },
      {
        path: "links/:uuid/edit",
        name: "LinkEditView",
        component: () =>
          import(
            /* webpackChunkName: "links-edit-view" */ "@/views/user/LinkEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Link",
          permission: 217,
        },
      },
      {
        path: "links/:uuid/delete",
        name: "LinkDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "links-delete-view" */ "@/views/user/LinkDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Link",
          permission: 218,
        },
      },
      {
        path: "links/:uuid/qr",
        name: "LinkQRGenerateView",
        component: () =>
          import(
            /* webpackChunkName: "links-qr-generate-view" */ "@/views/user/LinkQRGenerateView.vue"
          ),
        props: true,
        meta: {
          title: "Generate QR",
          permission: 216,
        },
      },
      {
        path: "service-types",
        name: "ServiceTypeBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "service-types-browse-view" */ "@/views/user/ServiceTypeBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Service Types",
          permission: 198,
        },
      },
      {
        path: "service-types/new",
        name: "ServiceTypeAddView",
        component: () =>
          import(
            /* webpackChunkName: "service-types-add-view" */ "@/views/user/ServiceTypeAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Service Type",
          permission: 197,
        },
      },
      {
        path: "service-types/:uuid",
        name: "ServiceTypeReadView",
        component: () =>
          import(
            /* webpackChunkName: "service-types-read-view" */ "@/views/user/ServiceTypeReadView.vue"
          ),
        props: true,
        meta: {
          title: "Service Type Info",
          permission: 198,
        },
      },
      {
        path: "service-types/:uuid/edit",
        name: "ServiceTypeEditView",
        component: () =>
          import(
            /* webpackChunkName: "service-types-edit-view" */ "@/views/user/ServiceTypeEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Service Type",
          permission: 199,
        },
      },
      {
        path: "service-types/:uuid/delete",
        name: "ServiceTypeDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "service-types-delete-view" */ "@/views/user/ServiceTypeDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Service Type",
          permission: 200,
        },
      },
      {
        path: "service-types/:uuid/manage-services",
        name: "ServiceTypeServiceManageView",
        component: () =>
          import(
            /* webpackChunkName: "service-types-service-manage-edit-view" */ "@/views/user/ServiceTypeServiceManageView.vue"
          ),
        props: true,
        meta: {
          title: "Manage Services",
          permission: 201,
        },
      },
      {
        path: "shops",
        name: "ShopBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "shops-browse-view" */ "@/views/user/ShopBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Shops",
          permission: 177,
        },
      },
      {
        path: "shops/new",
        name: "ShopAddView",
        component: () =>
          import(
            /* webpackChunkName: "shops-add-view" */ "@/views/user/ShopAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Shop",
          permission: 176,
        },
      },
      {
        path: "shops/:uuid",
        name: "ShopReadView",
        component: () =>
          import(
            /* webpackChunkName: "shops-read-view" */ "@/views/user/ShopReadView.vue"
          ),
        props: true,
        meta: {
          title: "Shop Info",
          permission: 177,
        },
      },
      {
        path: "shops/:uuid/mark-as-paid",
        name: "ShopMarkAsPaidView",
        component: () =>
          import(
            /* webpackChunkName: "shops-mark-as-paid-view" */ "@/views/user/ShopMarkAsPaidView.vue"
          ),
        props: true,
        meta: {
          title: "Shop Mark As Paid",
          permission: 169,
        },
      },
      {
        path: "shops/:uuid/edit",
        name: "ShopEditView",
        component: () =>
          import(
            /* webpackChunkName: "shops-edit-view" */ "@/views/user/ShopEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Shop",
          permission: 178,
        },
      },
      {
        path: "shops/:uuid/delete",
        name: "ShopDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "shops-delete-view" */ "@/views/user/ShopDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Shop",
          permission: 179,
        },
      },
      {
        path: "stalls",
        name: "StallBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "stalls-browse-view" */ "@/views/user/StallBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Stalls",
          permission: 210,
        },
      },
      {
        path: "stalls/new",
        name: "StallAddView",
        component: () =>
          import(
            /* webpackChunkName: "stalls-add-view" */ "@/views/user/StallAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Stall",
          permission: 209,
        },
      },
      {
        path: "stalls/:uuid",
        name: "StallReadView",
        component: () =>
          import(
            /* webpackChunkName: "stalls-read-view" */ "@/views/user/StallReadView.vue"
          ),
        props: true,
        meta: {
          title: "Stall Info",
          permission: 210,
        },
      },
      {
        path: "stalls/:uuid/edit",
        name: "StallEditView",
        component: () =>
          import(
            /* webpackChunkName: "stalls-edit-view" */ "@/views/user/StallEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Stall",
          permission: 211,
        },
      },
      {
        path: "stalls/:uuid/delete",
        name: "StallDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "stalls-delete-view" */ "@/views/user/StallDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Stall",
          permission: 212,
        },
      },
      {
        path: "asset-types",
        name: "AssetTypeBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "asset-types-browse-view" */ "@/views/user/AssetTypeBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Asset Types",
          permission: 164,
        },
      },
      {
        path: "asset-types/new",
        name: "AssetTypeAddView",
        component: () =>
          import(
            /* webpackChunkName: "asset-types-add-view" */ "@/views/user/AssetTypeAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Asset Type",
          permission: 163,
        },
      },
      {
        path: "asset-types/:uuid",
        name: "AssetTypeReadView",
        component: () =>
          import(
            /* webpackChunkName: "asset-types-read-view" */ "@/views/user/AssetTypeReadView.vue"
          ),
        props: true,
        meta: {
          title: "Asset Type Info",
          permission: 164,
        },
      },
      {
        path: "asset-types/:uuid/edit",
        name: "AssetTypeEditView",
        component: () =>
          import(
            /* webpackChunkName: "asset-types-edit-view" */ "@/views/user/AssetTypeEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Asset Type",
          permission: 165,
        },
      },
      {
        path: "asset-types/:uuid/delete",
        name: "AssetTypeDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "asset-types-delete-view" */ "@/views/user/AssetTypeDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete asset Type",
          permission: 166,
        },
      },
      {
        path: "monthly-overheads",
        name: "MonthlyOverheadBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "monthly-overheads-browse-view" */ "@/views/user/MonthlyOverheadBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Monthly Overheads",
          permission: 171,
        },
      },
      {
        path: "monthly-overheads/new",
        name: "MonthlyOverheadAddView",
        component: () =>
          import(
            /* webpackChunkName: "monthly-overheads-add-view" */ "@/views/user/MonthlyOverheadAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Monthly Overhead",
          permission: 170,
        },
      },
      {
        path: "monthly-overheads/:uuid",
        name: "MonthlyOverheadReadView",
        component: () =>
          import(
            /* webpackChunkName: "monthly-overheads-read-view" */ "@/views/user/MonthlyOverheadReadView.vue"
          ),
        props: true,
        meta: {
          title: "Monthly Overhead Info",
          permission: 171,
        },
      },
      {
        path: "monthly-overheads/:uuid/edit",
        name: "MonthlyOverheadEditView",
        component: () =>
          import(
            /* webpackChunkName: "monthly-overheads-edit-view" */ "@/views/user/MonthlyOverheadEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Monthly Overhead",
          permission: 172,
        },
      },
      {
        path: "monthly-overheads/:uuid/delete",
        name: "MonthlyOverheadDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "monthly-overheads-delete-view" */ "@/views/user/MonthlyOverheadDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Monthly Overhead",
          permission: 173,
        },
      },
      {
        path: "technician-faqs",
        name: "TechnicianFAQBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "technician-faqs-browse-view" */ "@/views/user/TechnicianFAQBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "FAQs",
          permission: 142,
        },
      },
      {
        path: "technician-faqs/:uuid",
        name: "TechnicianFAQReadView",
        component: () =>
          import(
            /* webpackChunkName: "technician-faqs-read-view" */ "@/views/user/TechnicianFAQReadView.vue"
          ),
        props: true,
        meta: {
          title: "FAQ Info",
          permission: 142,
        },
      },
      {
        path: "technician-faqs/:uuid/answer",
        name: "TechnicianFAQAnswerView",
        component: () =>
          import(
            /* webpackChunkName: "technician-faqs-answer-view" */ "@/views/user/TechnicianFAQAnswerView.vue"
          ),
        props: true,
        meta: {
          title: "Answer Technician FAQ",
          permission: 143,
        },
      },
      {
        path: "faqs",
        name: "FAQBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "faqs-browse-view" */ "@/views/user/FAQBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "FAQs",
          permission: 139,
        },
      },
      {
        path: "faqs/new",
        name: "FAQAddView",
        component: () =>
          import(
            /* webpackChunkName: "faqs-add-view" */ "@/views/user/FAQAddView.vue"
          ),
        props: true,
        meta: {
          title: "New FAQ",
          permission: 138,
        },
      },
      {
        path: "faqs/:uuid",
        name: "FAQReadView",
        component: () =>
          import(
            /* webpackChunkName: "faqs-read-view" */ "@/views/user/FAQReadView.vue"
          ),
        props: true,
        meta: {
          title: "FAQ Info",
          permission: 139,
        },
      },
      {
        path: "faqs/:uuid/edit",
        name: "FAQEditView",
        component: () =>
          import(
            /* webpackChunkName: "faqs-edit-view" */ "@/views/user/FAQEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit FAQ",
          permission: 140,
        },
      },
      {
        path: "faqs/:uuid/delete",
        name: "FAQDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "faqs-delete-view" */ "@/views/user/FAQDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete FAQ",
          permission: 141,
        },
      },
      {
        path: "question-categories",
        name: "QuestionCategoryBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "question-categories-browse-view" */ "@/views/user/QuestionCategoryBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Question Categories",
          permission: 115,
        },
      },
      {
        path: "question-categories/new",
        name: "QuestionCategoryAddView",
        component: () =>
          import(
            /* webpackChunkName: "question-categories-add-view" */ "@/views/user/QuestionCategoryAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Question Category",
          permission: 114,
        },
      },
      {
        path: "question-categories/:uuid",
        name: "QuestionCategoryReadView",
        component: () =>
          import(
            /* webpackChunkName: "question-categories-read-view" */ "@/views/user/QuestionCategoryReadView.vue"
          ),
        props: true,
        meta: {
          title: "Question Category Info",
          permission: 115,
        },
      },
      {
        path: "question-categories/:uuid/edit",
        name: "QuestionCategoryEditView",
        component: () =>
          import(
            /* webpackChunkName: "question-categories-edit-view" */ "@/views/user/QuestionCategoryEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Question Category",
          permission: 116,
        },
      },
      {
        path: "question-categories/:uuid/delete",
        name: "QuestionCategoryDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "question-categories-delete-view" */ "@/views/user/QuestionCategoryDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Question Category",
          permission: 117,
        },
      },
      {
        path: "products",
        name: "ProductBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "products-browse-view" */ "@/views/user/ProductBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Products",
          permission: 23,
        },
      },
      {
        path: "products/:uuid",
        name: "ProductReadView",
        component: () =>
          import(
            /* webpackChunkName: "products-read-view" */ "@/views/user/ProductReadView.vue"
          ),
        props: true,
        meta: {
          title: "Product Info",
          permission: 23,
        },
      },
      {
        path: "products/:uuid/edit",
        name: "ProductEditView",
        component: () =>
          import(
            /* webpackChunkName: "products-edit-view" */ "@/views/user/ProductEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Product",
          permission: 24,
        },
      },
      {
        path: "products/:uuid/delete",
        name: "ProductDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "products-delete-view" */ "@/views/user/ProductDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Product",
          permission: 25,
        },
      },
      {
        path: "new-deals",
        name: "NewDealBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "new-deals-browse-view" */ "@/views/user/NewDealBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "New Deals",
          permission: 133,
        },
      },
      {
        path: "new-deals/:uuid",
        name: "NewDealReadView",
        component: () =>
          import(
            /* webpackChunkName: "new-deals-read-view" */ "@/views/user/NewDealReadView.vue"
          ),
        props: true,
        meta: {
          title: "New Deal Info",
          permission: 133,
        },
      },
      {
        path: "admin-invoices",
        name: "AdminInvoiceBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-browse-view" */ "@/views/user/AdminInvoiceBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Invoices",
          permission: 34,
        },
      },
      {
        path: "admin-invoices/:uuid",
        name: "AdminInvoiceReadView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-read-view" */ "@/views/user/AdminInvoiceReadView.vue"
          ),
        props: true,
        meta: {
          title: "Invoice Info",
          permission: 34,
        },
      },
      {
        path: "admin-invoices/:uuid/reject",
        name: "AdminInvoiceRejectView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-reject-view" */ "@/views/user/AdminInvoiceRejectView.vue"
          ),
        props: true,
        meta: {
          title: "Reject Invoice",
          permission: 36,
        },
      },
      {
        path: "admin-invoices/:uuid/approve",
        name: "AdminInvoiceApproveView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-approve-view" */ "@/views/user/AdminInvoiceApproveView.vue"
          ),
        props: true,
        meta: {
          title: "Approve Invoice",
          permission: 35,
        },
      },
      {
        path: "admin-invoices/:uuid/mark-as-paid",
        name: "AdminInvoiceMarkAsPaidView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-mark-as-paid-view" */ "@/views/user/AdminInvoiceMarkAsPaidView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Paid",
          permission: 36,
        },
      },
      {
        path: "admin-invoices/:uuid/mark-as-paid-manual",
        name: "AdminInvoiceMarkAsPaidManualView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-mark-as-paid-manual-view" */ "@/views/user/AdminInvoiceMarkAsPaidManualView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Paid",
          permission: 132,
        },
      },
      {
        path: "admin-invoices/:uuid/mark-as-paid-by-customer",
        name: "AdminInvoicePayInvoiceView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-mark-as-paid-by-customer-view" */ "@/views/user/AdminInvoicePayInvoiceView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Paid",
          permission: 98,
        },
      },
      {
        path: "admin-invoices/:uuid/pay",
        name: "AdminInvoicePayView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-pay-view" */ "@/views/user/AdminInvoicePayView.vue"
          ),
        props: true,
        meta: {
          title: "Pay Invoice",
          permission: 35,
        },
      },
      {
        path: "admin-invoices/:uuid/delete",
        name: "AdminInvoiceDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "admin-invoices-delete-view" */ "@/views/user/AdminInvoiceDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Invoice",
          permission: 99,
        },
      },
      {
        path: "invoices",
        name: "InvoiceBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "invoices-browse-view" */ "@/views/user/InvoiceBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Invoices",
          permission: 31,
        },
      },
      {
        path: "invoices/new",
        name: "InvoiceAddView",
        component: () =>
          import(
            /* webpackChunkName: "invoices-add-view" */ "@/views/user/InvoiceAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Invoice",
          permission: 30,
        },
      },
      {
        path: "invoices/:uuid",
        name: "InvoiceReadView",
        component: () =>
          import(
            /* webpackChunkName: "invoices-read-view" */ "@/views/user/InvoiceReadView.vue"
          ),
        props: true,
        meta: {
          title: "Invoice Info",
          permission: 31,
        },
      },
      {
        path: "admin-invoices/:uuid/delete",
        name: "InvoiceDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "invoices-delete-view" */ "@/views/user/InvoiceDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Invoice",
          permission: 32,
        },
      },
      {
        path: "parcels",
        name: "ParcelBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "parcels-browse-view" */ "@/views/user/ParcelBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Parcels",
          permission: 180,
        },
      },
      {
        path: "parcels/:uuid",
        name: "ParcelReadView",
        component: () =>
          import(
            /* webpackChunkName: "parcel-read-view" */ "@/views/user/ParcelReadView.vue"
          ),
        props: true,
        meta: {
          title: "Parcel Info",
          permission: 180,
        },
      },
      {
        path: "bookings",
        name: "BookingBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "bookings-browse-view" */ "@/views/user/BookingBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Bookings",
          permission: 58,
        },
      },
      {
        path: "bookings/new",
        name: "BookingAddView",
        component: () =>
          import(
            /* webpackChunkName: "bookings-add-view" */ "@/views/user/BookingAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Booking",
          permission: 81,
        },
      },
      {
        path: "bookings/:uuid",
        name: "BookingReadView",
        component: () =>
          import(
            /* webpackChunkName: "booking-read-view" */ "@/views/user/BookingReadView.vue"
          ),
        props: true,
        meta: {
          title: "Booking Info",
          permission: 58,
        },
      },
      {
        path: "bookings/:uuid/cancel",
        name: "BookingCancelView",
        component: () =>
          import(
            /* webpackChunkName: "bookings-cancel-view" */ "@/views/user/BookingCancelView.vue"
          ),
        props: true,
        meta: {
          title: "Cancel Booking",
          permission: 60,
        },
      },
      {
        path: "bookings/:uuid/mark-as-not-received",
        name: "BookingMarkAsNotReceivedView",
        component: () =>
          import(
            /* webpackChunkName: "bookings-mark-as-not-received-view" */ "@/views/user/BookingMarkAsNotReceivedView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Not Received",
          permission: 60,
        },
      },
      {
        path: "bookings/:uuid/confirm",
        name: "BookingConfirmView",
        component: () =>
          import(
            /* webpackChunkName: "booking-confirm-view" */ "@/views/user/BookingConfirmView.vue"
          ),
        props: true,
        meta: {
          title: "Confirm Booking",
          permission: 59,
        },
      },
      {
        path: "bookings/:uuid/reject",
        name: "BookingRejectView",
        component: () =>
          import(
            /* webpackChunkName: "bookings-reject-view" */ "@/views/user/BookingRejectView.vue"
          ),
        props: true,
        meta: {
          title: "Reject Booking",
          permission: 60,
        },
      },
      {
        path: "bookings/:uuid/approve",
        name: "BookingApproveView",
        component: () =>
          import(
            /* webpackChunkName: "booking-approve-view" */ "@/views/user/BookingApproveView.vue"
          ),
        props: true,
        meta: {
          title: "Approve Booking",
          permission: 59,
        },
      },
      {
        path: "product-stock",
        name: "ProductStockBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "product-stock-browse-view" */ "@/views/user/ProductStockBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Product Stock",
          permission: 61,
        },
      },
      {
        path: "product-stock-logs",
        name: "ProductStockLogBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "product-stock-log-browse-view" */ "@/views/user/ProductStockLogBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Product Stock Log",
          permission: 78,
        },
      },
      {
        path: "product-stock-history",
        name: "ProductStockHistoryBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "product-stock-history-browse-view" */ "@/views/user/ProductStockHistoryBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Product Stock History",
          permission: 76,
        },
      },
      {
        path: "product-stock/manage",
        name: "ProductStockManageView",
        component: () =>
          import(
            /* webpackChunkName: "product-stock-manage-view" */ "@/views/user/ProductStockManageView.vue"
          ),
        props: true,
        meta: {
          title: "Manage Product Stock",
          permission: 62,
        },
      },
      {
        path: "product-stock/update-current",
        name: "ProductCurrentStockManageView",
        component: () =>
          import(
            /* webpackChunkName: "product-current-stock-manage-view" */ "@/views/user/ProductCurrentStockManageView.vue"
          ),
        props: true,
        meta: {
          title: "Manage Current Product Stock",
          permission: 167,
        },
      },
      {
        path: "unpaid-customers",
        name: "UnpaidCustomerBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "unpaid-customers-browse-view" */ "@/views/user/UnpaidCustomerBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Unpaid Customers",
          permission: 128,
        },
      },
      {
        path: "unpaid-technicians",
        name: "UnpaidTechnicianBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "unpaid-technicians-browse-view" */ "@/views/user/UnpaidTechnicianBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Unpaid Technicians",
          permission: 129,
        },
      },
      {
        path: "pre-orders",
        name: "PreOrderBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "pre-orders-browse-view" */ "@/views/user/PreOrderBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Pre Orders",
          permission: 202,
        },
      },
      {
        path: "pre-orders/new",
        name: "TechnicianPreOrderAddView",
        component: () =>
          import(
            /* webpackChunkName: "technician-pre-order-add-view" */ "@/views/user/TechnicianPreOrderAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Pre-Order",
          // permission: 81,
        },
      },
      {
        path: "pre-orders/:uuid",
        name: "PreOrderReadView",
        component: () =>
          import(
            /* webpackChunkName: "pre-orders-read-view" */ "@/views/user/PreOrderReadView.vue"
          ),
        props: true,
        meta: {
          title: "Pre Order Info",
          permission: 202,
        },
      },
       {
        path: "pre-orders/:uuid/mark-as-quoted",
        name: "PreOrderMarkAsQuotedView",
        component: () =>
          import(
            /* webpackChunkName: "pre-orders-mark-as-quoted-view" */ "@/views/user/PreOrderMarkAsQuotedView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Quoted",
          permission: 203,
        },
      },
      {
        path: "orders",
        name: "OrderBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "orders-browse-view" */ "@/views/user/OrderBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Orders",
          permission: 43,
        },
      },
      {
        path: "orders/new",
        name: "OrderAddView",
        component: () =>
          import(
            /* webpackChunkName: "orders-add-view" */ "@/views/user/OrderAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Order",
          permission: 42,
        },
      },
      {
        path: "orders/:uuid",
        name: "OrderReadView",
        component: () =>
          import(
            /* webpackChunkName: "orders-read-view" */ "@/views/user/OrderReadView.vue"
          ),
        props: true,
        meta: {
          title: "Order Info",
          permission: 43,
        },
      },
      {
        path: "orders/:uuid/edit",
        name: "OrderEditView",
        component: () =>
          import(
            /* webpackChunkName: "orders-edit-view" */ "@/views/user/OrderEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Order",
          permission: 44,
        },
      },
      {
        path: "orders/:uuid/mark-as-converting",
        name: "OrderMarkAsConvertingView",
        component: () =>
          import(
            /* webpackChunkName: "orders-mark-as-converting-view" */ "@/views/user/OrderMarkAsConvertingView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Converting",
          permission: 79,
        },
      },
      {
        path: "orders/:uuid/mark-as-completed",
        name: "OrderMarkAsCompletedView",
        component: () =>
          import(
            /* webpackChunkName: "orders-mark-as-completed-view" */ "@/views/user/OrderMarkAsCompletedView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Completed",
          permission: 79,
        },
      },
      {
        path: "orders/:uuid/mark-as-converted",
        name: "OrderMarkAsConvertedView",
        component: () =>
          import(
            /* webpackChunkName: "orders-mark-as-converted-view" */ "@/views/user/OrderMarkAsConvertedView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Converted",
          permission: 79,
        },
      },
      {
        path: "orders/:uuid/mark-as-ready-for-delivery",
        name: "OrderMarkAsReadyToDeliveryView",
        component: () =>
          import(
            /* webpackChunkName: "orders-mark-as-ready-for-delivery-view" */ "@/views/user/OrderMarkAsReadyToDeliveryView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Ready for Delivery",
          permission: 79,
        },
      },
      {
        path: "orders/:uuid/mark-as-posted",
        name: "OrderMarkAsPostedView",
        component: () =>
          import(
            /* webpackChunkName: "orders-mark-as-posted-view" */ "@/views/user/OrderMarkAsPostedView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Posted",
          permission: 79,
        },
      },
      {
        path: "orders/:uuid/mark-as-collected",
        name: "OrderMarkAsCollectedView",
        component: () =>
          import(
            /* webpackChunkName: "orders-mark-as-collected-view" */ "@/views/user/OrderMarkAsCollectedView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Collected",
          permission: 79,
        },
      },
      {
        path: "orders/:uuid/upload",
        name: "OrderUploadVideoView",
        component: () =>
          import(
            /* webpackChunkName: "orders-upload-view" */ "@/views/user/OrderUploadVideoView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Order",
          permission: 79,
        },
      },
      {
        path: "orders/:uuid/create-invoice",
        name: "OrderInvoiceCreateView",
        component: () =>
          import(
            /* webpackChunkName: "orders-create-invoice-view" */ "@/views/user/OrderInvoiceCreateView.vue"
          ),
        props: true,
        meta: {
          title: "Create Invoice",
          permission: 79,
        },
      },
      {
        path: "orders/:parentUuid/files/:uuid",
        name: "OrderFileReadView",
        component: () =>
          import(
            /* webpackChunkName: "order-files-read-view" */ "@/views/user/OrderFileReadView.vue"
          ),
        props: true,
        meta: {
          title: "Order File Info",
          permission: 43,
        },
      },
      {
        path: "orders/:parentUuid/files/:uuid/delete",
        name: "OrderFileDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "order-files-delete-view" */ "@/views/user/OrderFileDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Order File Delete",
          permission: 97,
        },
      },
      {
        path: "tqc-requests",
        name: "TQCRequestsBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tqc-requests-browse-view" */ "@/views/user/TQCRequestsBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Quality Check Requests",
          permission: 119,
        },
      },
      {
        path: "tqc-requests/:uuid",
        name: "TQCRequestsReadView",
        component: () =>
          import(
            /* webpackChunkName: "tqc-requests-read-view" */ "@/views/user/TQCRequestsReadView.vue"
          ),
        props: true,
        meta: {
          title: "TQC Requests Info",
          permission: 119,
        },
      },
      {
        path: "tqc-requests/:uuid/mark-as-completed",
        name: "TQCRequestsMarkAsCompletedView",
        component: () =>
          import(
            /* webpackChunkName: "tqc-requests-mark-as-completed-view" */ "@/views/user/TQCRequestsMarkAsCompletedView.vue"
          ),
        props: true,
        meta: {
          title: "Mark as Completed",
          permission: 120,
        },
      },
      {
        path: "tqc-requests/:parentUuid/files/:uuid",
        name: "TQCRequestsFileReadView",
        component: () =>
          import(
            /* webpackChunkName: "tqc-requests-files-read-view" */ "@/views/user/TQCRequestsFileReadView.vue"
          ),
        props: true,
        meta: {
          title: "Request File Info",
          permission: 119,
        },
      },
      {
        path: "customers",
        name: "CustomerBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "customers-browse-view" */ "@/views/user/CustomerBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Customers",
          permission: 107,
        },
      },
      {
        path: "customers/:uuid",
        name: "CustomerReadView",
        component: () =>
          import(
            /* webpackChunkName: "customers-read-view" */ "@/views/user/CustomerReadView.vue"
          ),
        props: true,
        meta: {
          title: "Customer Info",
          permission: 107,
        },
      },
      {
        path: "customer-orders",
        name: "CustomerOrderBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "customer-orders-browse-view" */ "@/views/user/CustomerOrderBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Customer Orders",
          permission: 226,
        },
      },
      {
        path: "customer-orders/:uuid",
        name: "CustomerOrderReadView",
        component: () =>
          import(
            /* webpackChunkName: "customer-orders-read-view" */ "@/views/user/CustomerOrderReadView.vue"
          ),
        props: true,
        meta: {
          title: "Customer Order",
          permission: 226,
        },
      },
      {
        path: "utils",
        name: "UtilBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "utils-browse-view" */ "@/views/user/UtilBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Utils",
          permission: 46,
        },
      },
      {
        path: "utils/new",
        name: "UtilAddView",
        component: () =>
          import(
            /* webpackChunkName: "utils-add-view" */ "@/views/user/UtilAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Util",
          permission: 45,
        },
      },
      {
        path: "utils/:uuid",
        name: "UtilReadView",
        component: () =>
          import(
            /* webpackChunkName: "utils-read-view" */ "@/views/user/UtilReadView.vue"
          ),
        props: true,
        meta: {
          title: "Util Info",
          permission: 46,
        },
      },
      {
        path: "utils/:uuid/edit",
        name: "UtilEditView",
        component: () =>
          import(
            /* webpackChunkName: "utils-edit-view" */ "@/views/user/UtilEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Util",
          permission: 47,
        },
      },
      {
        path: "reviews",
        name: "ReviewBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-browse-view" */ "@/views/user/ReviewBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Reviews",
          permission: 50,
        },
      },
      {
        path: "reviews/new",
        name: "ReviewAddView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-add-view" */ "@/views/user/ReviewAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Review",
          permission: 48,
        },
      },
      {
        path: "reviews/:uuid",
        name: "ReviewReadView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-read-view" */ "@/views/user/ReviewReadView.vue"
          ),
        props: true,
        meta: {
          title: "Review Info",
          permission: 14,
        },
      },
      {
        path: "reviews/:uuid/edit",
        name: "ReviewEditView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-edit-view" */ "@/views/user/ReviewEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Review",
          permission: 51,
        },
      },
      {
        path: "reviews/:uuid/delete",
        name: "ReviewDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "reviews-delete-view" */ "@/views/user/ReviewDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Review",
          permission: 52,
        },
      },
      {
        path: "sales-dashboard",
        name: "SalesDashboardView",
        component: () =>
          import(
            /* webpackChunkName: "sales-dashboard-view" */ "@/views/sales/DashboardView.vue"
          ),
        props: true,
        meta: {
          title: "Sales Dashboard",
          permission: 102,
        },
      },
      {
        path: "sales-open-invoices",
        name: "SalesOpenInvoicesView",
        component: () =>
          import(
            /* webpackChunkName: "sales-open-invoices-view" */ "@/views/sales/OpenInvoicesView.vue"
          ),
        props: true,
        meta: {
          title: "Sales Open Invoices",
          permission: 103,
        },
      },
      {
        path: "sales-paid-invoices",
        name: "SalesPaidInvoicesView",
        component: () =>
          import(
            /* webpackChunkName: "sales-paid-invoices-view" */ "@/views/sales/PaidInvoicesView.vue"
          ),
        props: true,
        meta: {
          title: "Sales Paid Invoices",
          permission: 104,
        },
      },
      {
        path: "sales-converted-orders",
        name: "SalesConvertedOrdersView",
        component: () =>
          import(
            /* webpackChunkName: "sales-converted-orders-view" */ "@/views/sales/ConvertedOrdersView.vue"
          ),
        props: true,
        meta: {
          title: "Sales Converted Orders",
          permission: 105,
        },
      },
      {
        path: "sales-processing-orders",
        name: "SalesProcessingOrdersView",
        component: () =>
          import(
            /* webpackChunkName: "sales-processing-orders-view" */ "@/views/sales/ProcessingOrdersView.vue"
          ),
        props: true,
        meta: {
          title: "Sales Processing Orders",
          permission: 106,
        },
      },
      {
        path: "sales-pending-deals",
        name: "SalesPendingDealsView",
        component: () =>
          import(
            /* webpackChunkName: "sales-pending-deals-view" */ "@/views/sales/PendingDealsView.vue"
          ),
        props: true,
        meta: {
          title: "Sales Pending Deals",
          permission: 125,
        },
      },
      {
        path: "sales-paid-drives-deals",
        name: "PaidDrivesDealsView",
        component: () =>
          import(
            /* webpackChunkName: "sales-paid-drives-deals-view" */ "@/views/sales/PaidDrivesDealsView.vue"
          ),
        props: true,
        meta: {
          title: "Sales Paid Drives Deals",
          permission: 137,
        },
      },
      {
        path: "tasks",
        name: "TaskBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "tasks-browse-view" */ "@/views/user/TaskBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Tasks",
          permission: 100,
        },
      },
      {
        path: "tasks/new",
        name: "TaskAddView",
        component: () =>
          import(
            /* webpackChunkName: "tasks-add-view" */ "@/views/user/TaskAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Task",
          permission: 101,
        },
      },
      {
        path: "tasks/:uuid",
        name: "TaskReadView",
        component: () =>
          import(
            /* webpackChunkName: "tasks-read-view" */ "@/views/user/TaskReadView.vue"
          ),
        props: true,
        meta: {
          title: "Task Info",
          permission: 100,
        },
      },
      {
        path: "tasks/:uuid/mark-as-in-progress",
        name: "TaskMarkAsInProgressView",
        component: () =>
          import(
            /* webpackChunkName: "tasks-as-in-progress-view" */ "@/views/user/TaskMarkAsInProgressView.vue"
          ),
        props: true,
        meta: {
          title: "Mark Task as In Progress",
          permission: 100,
        },
      },
      {
        path: "tasks/:uuid/mark-as-completed",
        name: "TaskMarkAsCompletedView",
        component: () =>
          import(
            /* webpackChunkName: "tasks-as-completed-view" */ "@/views/user/TaskMarkAsCompletedView.vue"
          ),
        props: true,
        meta: {
          title: "Mark Task as Completed",
          permission: 100,
        },
      },
      {
        path: "tasks/:uuid/edit",
        name: "TaskEditView",
        component: () =>
          import(
            /* webpackChunkName: "tasks-edit-view" */ "@/views/user/TaskEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Task",
          permission: 101,
        },
      },
      {
        path: "tasks/:uuid/delete",
        name: "TaskDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "tasks-delete-view" */ "@/views/user/TaskDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Task",
          permission: 101,
        },
      },
      {
        path: "clockwise-settings",
        name: "ClockwiseSettingBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-settings-browse-view" */ "@/views/user/ClockwiseSettingBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "ClockWise Settings",
          permission: 162,
        },
      },
      {
        path: "clockwise-settings/new",
        name: "ClockwiseSettingAddView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-settings-add-view" */ "@/views/user/ClockwiseSettingAddView.vue"
          ),
        props: true,
        meta: {
          title: "New ClockWise Setting",
          permission: 161,
        },
      },
      {
        path: "roles",
        name: "RoleBrowseView",
        component: () =>
          import(
            /* webpackChunkName: "roles-browse-view" */ "@/views/user/RoleBrowseView.vue"
          ),
        props: true,
        meta: {
          title: "Roles",
          permission: 14,
        },
      },
      {
        path: "roles/new",
        name: "RoleAddView",
        component: () =>
          import(
            /* webpackChunkName: "roles-add-view" */ "@/views/user/RoleAddView.vue"
          ),
        props: true,
        meta: {
          title: "New Role",
          permission: 13,
        },
      },
      {
        path: "roles/:uuid",
        name: "RoleReadView",
        component: () =>
          import(
            /* webpackChunkName: "roles-read-view" */ "@/views/user/RoleReadView.vue"
          ),
        props: true,
        meta: {
          title: "Role Info",
          permission: 14,
        },
      },
      {
        path: "roles/:uuid/edit",
        name: "RoleEditView",
        component: () =>
          import(
            /* webpackChunkName: "roles-edit-view" */ "@/views/user/RoleEditView.vue"
          ),
        props: true,
        meta: {
          title: "Edit Role",
          permission: 15,
        },
      },
      {
        path: "roles/:uuid/delete",
        name: "RoleDeleteView",
        component: () =>
          import(
            /* webpackChunkName: "roles-delete-view" */ "@/views/user/RoleDeleteView.vue"
          ),
        props: true,
        meta: {
          title: "Delete Role",
          permission: 16,
        },
      },
      {
        path: "logout",
        name: "LogoutView",
        component: () =>
          import(
            /* webpackChunkName: "logout-view" */ "@/views/LogoutView.vue"
          ),
        props: true,
      },
    ],
  },
  {
    path: "/",
    component: LayoutMain,
    children: [
      {
        path: "booking/:location",
        name: "CustomerBookingView",
        component: () =>
          import(
            /* webpackChunkName: "customer-booking-view" */ "@/views/CustomerBookingView.vue"
          ),
        props: true,
        meta: {
          title: "Booking",
        },
      },
      {
        path: "booking-confirmation",
        name: "CustomerBookingConfirmView",
        component: () =>
          import(
            /* webpackChunkName: "customer-booking-confirmation-view" */ "@/views/CustomerBookingConfirmView.vue"
          ),
        props: true,
        meta: {
          title: "Booking confirmation",
        },
      },
      {
        path: "privacy-policy",
        name: "PrivacyPolicyView",
        component: () =>
          import(
            /* webpackChunkName: "privacy-policy-view" */ "@/views/PrivacyPolicyView.vue"
          ),
        props: true,
        meta: {
          title: "Privacy Policy",
        },
      },
      {
        path: "clockwise-user-activity",
        name: "ClockWiseUserActivityView",
        component: () =>
          import(
            /* webpackChunkName: "clockwise-user-activity-view" */ "@/views/ClockWiseUserActivityView.vue"
          ),
        props: true,
        meta: {
          title: "ClockWise User Activity",
        },
      },
      {
        path: "cities",
        name: "CityView",
        component: () =>
          import(
            /* webpackChunkName: "city-view" */ "@/views/CityView.vue"
          ),
        props: true,
        meta: {
          title: "City",
        },
      },
      {
        path: "track",
        name: "OrderHistoryView",
        component: () =>
          import(
            /* webpackChunkName: "order-history-view" */ "@/views/OrderHistoryView.vue"
          ),
        props: true,
        meta: {
          title: "Order History",
        },
      },
       {
        path: "order",
        name: "OrderFormView",
        component: () =>
          import(
            /* webpackChunkName: "order-form-view" */ "@/views/OrderFormView.vue"
          ),
        props: true,
        meta: {
          title: "Order Form",
        },
      },
      {
        path: "pre-order/:location",
        name: "PreOrderFormView",
        component: () =>
          import(
            /* webpackChunkName: "pre-order-form-view" */ "@/views/PreOrderFormView.vue"
          ),
        props: true,
        meta: {
          title: "Pre-Order Form",
        },
      },
      {
        path: "terms-of-service",
        name: "TermsOfServiceView",
        component: () =>
          import(
            /* webpackChunkName: "terms-of-service" */ "@/views/TermsOfServiceView.vue"
          ),
        props: true,
        meta: {
          title: "Terms of service",
        },
      },
      {
        path: "qr/:short_code",
        name: "LinkClickView",
        component: () =>
          import(
            /* webpackChunkName: "link-click-view" */ "@/views/LinkClickView.vue"
          ),
        props: true,
        meta: {
          title: "Redirecting",
        },
      },
      {
        path: "/:catchAll(.*)",
        name: "ErrorNotFoundView",
        component: () =>
          import(
            /* webpackChunkName: "not-found-view" */ "@/views/error/ErrorNotFoundView.vue"
          ),
        props: true,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If there's a saved position (e.g., navigating back), use it
    if (savedPosition) {
      return savedPosition;
    }
    // Otherwise, scroll to the top
    return { x: 0, y: 0 };
  },
});
router.beforeEach((to, from, next) => {
  // Retrieve user's access codes
  const permissions =
    store.state.account && store.state.account.data && Array.isArray(store.state.account.data.permissions)
      ? store.state.account.data.permissions
      : [];

  // Check if the route requires a permission
  if (to.meta.permission) {
    if (permissions.includes(to.meta.permission)) {
      // User has permission
      return next();
    } else {
      // User does not have permission
      return next({ name: "ErrorNotFoundView" });
    }
  }
  // If route doesn't require a permission, proceed normally
  return next();
});
router.afterEach((to) => {
  //BOC:[page title]
  Vue.nextTick(() => {
    document.title = to.meta.title
      ? to.meta.title + " | Tapes to Digital Team Portal"
      : "Tapes to Digital Team Portal";
  });
  //EOC
});

export default router;
